module.exports = __webpack_public_path__ + "img/p2.3f0286ee.png";